// extracted by mini-css-extract-plugin
export default {"root":"AddAttributeModal_root__XKx8w","form":"AddAttributeModal_form__q06VO","formInput":"AddAttributeModal_formInput__nkAXN","footer":"AddAttributeModal_footer__oiHkS"};